export default __webpack_public_path__ + "media/images/rabbit_ui_conversation-eeb464f438b3158c2328f350ecea7b12.png";